var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44073_25108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 19.9996C39.9997 12.0704 35.3852 5.21913 28.6953 1.98413V38.015C35.3852 34.7801 39.9997 27.9288 39.9997 19.9996Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9996C0 27.9288 4.61445 34.7801 11.3044 38.0151V1.98413C4.61445 5.21913 0 12.0704 0 19.9996Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7812 19.9989C14.7812 22.8804 17.1172 25.2163 19.9987 25.2163C22.8802 25.2163 25.2161 22.8804 25.2161 19.9989V18.2598H14.7812V19.9989Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9561 16.5223H21.7387C21.7387 15.5619 20.96 14.7832 19.9995 14.7832C19.0391 14.7832 18.2604 15.5619 18.2604 16.5223H13.043C13.043 17.4829 13.8796 18.2615 14.84 18.2615H14.7821C14.7821 19.222 15.5607 20.0006 16.5213 20.0006C16.5213 20.9612 17.2998 21.7398 18.2604 21.7398H21.7387C22.6992 21.7398 23.4778 20.9612 23.4778 20.0006C24.4384 20.0006 25.217 19.222 25.217 18.2615H25.159C26.1195 18.2615 26.9561 17.4829 26.9561 16.5223Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44073_25108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/MX.524d6fcd5b52e8a1e17a8520ed7cdbcb.svg";
export { ForwardRef as ReactComponent };